import { useContext, useState } from "react";
import CustomTable from "../../components/CustomTable";
import useApi from "../../hooks/useApi";
import { ListClass, ListBranch } from "../../constants/API/API";
import useFilter from "../../hooks/useFilter";
import { AppStateContext } from "../../context/AppContext";
import { StatusChangeClass } from "../../constants/API/API";
import { message, Select, Space, Button } from "antd";
import moment from "moment";
import { Switch } from "antd";
import { useEffect } from "react";
import { EyeOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router";

const Class = () => {
  const { setPageHeading } = useContext(AppStateContext);
  setPageHeading("Class Attendance Management");

  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState(new Date().getTime());
  const [data, setData] = useState([]);
  const [totalDocs, setTotalDocs] = useState(0);
  const [branchList, setBranchList] = useState([]);
  const [filters, setFilters] = useFilter({
    sortField: "createdAt",
    sort: "desc",
    branchId: undefined,
  });
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchData() {
      try {
        const [branchRes] = await Promise.all([ListBranch()]);
        setBranchList(branchRes.data.list || []);
      } catch (e) {
        message.error("Failed to fetch filter data");
        setBranchList([]);
      }
    }
    fetchData();
  }, []);

  const handleStatusChange = async (checked, classes) => {
    setLoading(true);
    try {
      await StatusChangeClass(classes._id, { isActive: checked });
      message.success(
        `Class ${checked ? "activated" : "deactivated"} successfully`
      );
      setRefresh(new Date().getTime()); // Refresh list
    } catch (error) {
      message.error("Failed to update status");
      setLoading(false);
    }
  };

  const handleBranchFilter = (value) => {
    setFilters((prev) => ({
      ...prev,
      branchId: value,
      page: 1,
    }));
  };

  const handleView = (record) => {
    navigate(`/class-attendance/${record?._id}`);
  };

  useApi({
    callback: ListClass,
    payload: filters,
    dependencies: [refresh, filters],
    shouldCallApi: true,
    setLoading,
    onSuccess: ({ list, totalDocs }) => {
      setData(list);
      setTotalDocs(totalDocs);
      setLoading(false);
    },
    onError: () => {
      setLoading(false);
    },
  });

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (_, item) => (
        <>
          <p>{item?.name}</p>
        </>
      ),
    },
    {
      title: "Branch",
      dataIndex: "branchDetails",
      key: "branchDetails",
      render: (_, item) => item?.branchId?.name || "-",
    },
    {
      title: "Days",
      dataIndex: "schedules",
      key: "days",
      render: (text, record) => {
        if (!record.schedules || !record.schedules.length) return "-";
        return record.schedules
          .map((schedule) => schedule.dayOfWeek)
          .join(", ");
      },
    },
    {
      title: "Status",
      dataIndex: "isActive",
      key: "isActive",
      render: (text, record) => (
        <Switch
          checked={record.isActive}
          onChange={(checked) => handleStatusChange(checked, record)}
          disabled={true}
        />
      ),
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text, record) => moment(record.createdAt).format("ll"),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Space size="middle">
          <Button
            type="primary"
            onClick={() => handleView(record)}
            icon={<EyeOutlined />}
            title="View"
          />
        </Space>
      ),
    },
  ];

  const renderFilters = () => {
    return (
      <Space>
        <Select
          allowClear
          style={{ width: 200 }}
          placeholder="Filter by Branch"
          onChange={handleBranchFilter}
          value={filters.branchId}
        >
          <Select.Option value="">All Branches</Select.Option>
          {branchList.map((branch) => (
            <Select.Option key={branch._id} value={branch._id}>
              {branch.name}
            </Select.Option>
          ))}
        </Select>
      </Space>
    );
  };

  return (
    <div>
      <CustomTable
        addFn={false}
        data={data}
        loading={loading}
        filters={filters}
        setFilters={setFilters}
        columns={columns}
        totalDocs={totalDocs}
        searchField={["name"]}
        searchPlaceholder="Search by class Name"
        customFilter={renderFilters}
      />

      {/* <ClassView
        viewVisible={viewVisible}
        setViewVisible={(visible) => {
          setViewVisible(visible);
          if (!visible) {
            setSelectedClass(null);
          }
        }}
        selectedClass={selectedClass}
      /> */}
    </div>
  );
};

export default Class;

{
  /* Calendar on the left */
}
// <Col span={24} md={10} lg={10}>
//   <Card title="Select Date" className="clander-sellect-mainj">
//     <Calendar
//       fullscreen={false}
//       value={dayjs(selectedDate)}
//       onSelect={(date) => setSelectedDate(date.format("YYYY-MM-DD"))}
//     />
//   </Card>
// </Col>
